<template>
  <BaseInput :label="label" :errors="errors" :hasIcon="hasIcon">
    <component :is="loadIconPath" v-if="iconType" :iconColor="iconColor" />
    <input
      multiple
      type="file"
      id="multiFileInput"
      :name="name"
      :class="{ hasErrors: errors }"
      :placeholder="placeholder"
      :accept="aceptedFileTypes"
      @change="$emit(`updateFiles`, $event.target.files)"
    />

    <Paperclip />
  </BaseInput>
</template>

<script setup>
import { defineAsyncComponent, computed } from 'vue';
import BaseInput from '@/components/ui/inputs/BaseInput.vue';
import Paperclip from '@/components/icons/Paperclip.vue';
import useFileInputValidations from '@/composables/validations/useFileInputValidations';

const { ACCEPTED_FILE_TYPES } = useFileInputValidations();

const props = defineProps({
  name: { type: String, default: 'multiFileUploadField' },
  label: { type: String, default: 'Default label' },
  placeholder: { type: String, default: 'Default placeholder' },
  iconType: { type: String, required: false, default: '' },
  iconColor: { type: String, required: false },
  errors: {
    type: String,
    default: null,
  },
});
const $emit = defineEmits(['updateFiles']);
const aceptedFileTypes = ACCEPTED_FILE_TYPES.reduce(
  (item, acc) => (acc = `${item} ${acc}`),
  '',
).trim();
const hasIcon = !!props.iconType;
const loadIconPath = computed(() => defineAsyncComponent(() => import(/* @vite-ignore */ `../../icons/${props.iconType}.vue`)));
</script>

<style lang="scss">
input[type="file"]::file-selector-button {
  display: none;
}

.paperclip-icon {
  right: 10px;
  left: unset !important;
}
</style>
